import { LocationFilter as AntdLocationFilter } from "@empglabs/backoffice-ui-kit"

const LocationFilter = props => {
  return <AntdLocationFilter {...props} />
}

export default LocationFilter
